import styled from "styled-components"

export const Wrapper = styled.div`
  display: grid;
  justify-items: start;
  row-gap: 20px;
`

export const Buttons = styled.div`
  column-gap: 10px;
  display: grid;
  grid-template-columns: repeat(2, max-content);
`

export const Row = styled.div`
  column-gap: 32px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 32px;
`
